<div class="form-row">
  <div class="form-label">
    <label for="has-plinth">{{ 'closet-doors.door-configuration.has-plinth' | translate }}</label>
  </div>
  <div class="form-switch">
    <span class="mr-2">{{ 'closet-doors.door-configuration.no' | translate }}</span>
    <div class="custom-control custom-switch">
      <input
        type="checkbox"
        class="custom-control-input"
        id="has-plinth"
        [(ngModel)]="current.closetDoors.hasPlinth"
        (change)="selectHasPlinth()" />
      <label class="custom-control-label" for="has-plinth">{{
        'closet-doors.door-configuration.yes' | translate
      }}</label>
    </div>
  </div>
</div>

@if (current.closetDoors.hasPlinth) {
  <div class="form-row">
    <div class="form-label">
      <label for="need-baseboard-compensator"
        >{{ 'closet-doors.door-configuration.need-baseboard-compensator' | translate
        }}<a class="casto-tooltip" [tooltip]="baseboardAccessory?.toolTip?.descriptionFr">?</a></label
      >
    </div>
    <div class="form-switch">
      <span class="mr-2">{{ 'closet-doors.door-configuration.no' | translate }}</span>
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          id="need-baseboard-compensator"
          [(ngModel)]="current.closetDoors.needBaseboardCompensator"
          (change)="selectNeedBaseboardCompensator()" />
        <label class="custom-control-label" for="need-baseboard-compensator">{{
          'closet-doors.door-configuration.yes' | translate
        }}</label>
      </div>
    </div>
  </div>

  @if (current.closetDoors.needBaseboardCompensator) {
    <div class="form-row">
      <div class="form-label">
        <label for="baseboard-compensator-qty">{{
          'closet-doors.door-configuration.baseboard-compensator-qty' | translate
        }}</label>
      </div>
      <div class="form-input">
        <div class="inputNumber">
          <input
            type="number"
            min="1"
            max="2"
            id="baseboard-compensator-qty"
            autocorrect="off"
            spellcheck="false"
            [(ngModel)]="current.closetDoors.baseboardCompensatorQty" />
        </div>
      </div>
    </div>
  }
}
